export default {
    'ORDER_BY' : 'o-by',
    'SORT_BY' : 's-by',
    'LOCATION' : 'l',
    'JOB_TYPE' : 'jt',
    'KEYWORD' : 'kw',
}
